export enum ProjectStatusValue {
  IN_PROGRESS = 'in_progress',
  BLOCKED = 'blocked',
  NOT_STARTED = 'not_started',
  ON_HOLD = 'on_hold',
}
